import { Id } from "PFTypes";

export const orderConfigKeys = {
  target: (accountId: Id, target: string) => ["saas_admin", "account", accountId, "orderConfig", target]
};
